// This file contains compile-time defined variables.

export const NAME: string = '#{NAME}';

export const VERSION: string = '#{VERSION}';
